import React from 'react';
import { Link } from 'react-router-dom';

export default function GameGuideLink({ slug, gameName }) {
  return (
    <p style={{ margin: '1.5rem 0 0', lineHeight: 1.6 }}>
      Full write-up for other sites:{' '}
      <Link to={`/blog/${slug}/`} style={{ color: 'var(--hover-border-color)' }}>
        {gameName} guide
      </Link>
      .
    </p>
  );
}
